import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import ModalUpdate from './ModalUpdate'
import { useSelector } from 'react-redux'
import NavRoleOrg from '../../../components/nav-role-org'
import { listIncomeCertificateAPI } from '../../../services/income/certficate'

import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { fnDateEn } from '../../../helper/fnDateEn'
import { BsPencilSquare } from 'react-icons/bs'
import styled from 'styled-components'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import UseAllCertificateActive from '../../../hooks/use-certificate-active'

export default function CertificateIncomePage() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const totalLimits = 20
  const [totalRows, setTotalRow] = useState(0)
  const [page, setPage] = useState(1)
  const [dataTable, setDataTable] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const optionActive = UseAllCertificateActive()
  const [showModal, setShowModal] = useState({ isShow: false, data: null })
  useEffect(() => {
    const body = {
      page: 1,
      orgId
    }
    if (orgId) {
      fnGetData(body)
    }
  }, [orgId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    setPage(body.page)
    const resp = await listIncomeCertificateAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search
    }
    fnGetData(body)
  }

  return (
    <>
      <NavTitle>
        <TextNavTitle>Certificate</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3 ">
            <Row>
              <Col md={4} className="my-auto">
                <label className="small">
                  Total: {totalRows.toLocaleString()}
                </label>
              </Col>

              <Col md={8}>
                <BoxFilter className="justify-content-end">
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <div style={{ minWidth: 180 }}>
                    <AutocompleteCustom
                      placeholder="Active Status"
                      className="w-100"
                      isClearable={true}
                      // value={}
                      options={optionActive}
                      onChange={(d) => {
                        // setEjipStatus(e)
                        // onSelectStatus(e?.value)
                        const body = {
                          ...bodyFilter,
                          page: 1,
                          active: d?.value ?? ''
                        }
                        fnGetData(body)
                      }}
                    />
                  </div>
                  <Button
                    className="px-4"
                    onClick={() => {
                      setShowModal({ isShow: true, data: null })
                    }}
                  >
                    <FaPlus className="me-2" />
                    Add
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', width: '50px' }}
                >
                  #
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', width: '100px' }}
                >
                  Code
                </th>
                <th
                  className="fw-normal"
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Name
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                >
                  Certificate
                </th>

                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                >
                  Cert Date
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                >
                  Period Date
                </th>
                <th className="fw-normal text-end">Amount</th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', width: '80px' }}
                >
                  Status
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', width: '100px' }}
                >
                  Update
                </th>
                <th className="fw-normal text-center">Action</th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {isLoading ? (
                <TableSkeletonBody colSpan={10} rowSpan={7} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td className="">{d.code}</td>
                    <td className="">
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td className="">{d.paymentNameCer}</td>
                    <td className="">
                      {fnDateEn(d?.paymentCerStart).format('DD/MM/YYYY')} to{' '}
                      {fnDateEn(d?.paymentCerExpires).format('DD/MM/YYYY')}
                    </td>
                    <td className="">
                      {fnDateEn(d?.cerPeriodStart).format('DD/MM/YYYY')} to{' '}
                      {fnDateEn(d?.cerPeriodEnd).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-end">
                      {d.paymentCerAmounts?.toLocaleString()}
                    </td>
                    <td
                      className=""
                      style={{
                        color: d.active ? '#009b47' : '#989898'
                      }}
                    >
                      {' '}
                      {d.activeName}
                    </td>
                    <td className="">
                      {fnDateEn(d?.updateDate).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="light"
                        className="text-primary shadow-sm"
                        onClick={() => {
                          setShowModal({ isShow: true, data: d })
                        }}
                      >
                        <BsPencilSquare />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={10} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)

              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showModal.isShow && (
        <ModalUpdate
          orgId={orgId}
          data={showModal.data}
          fnGetData={() => fnGetData(bodyFilter)}
          open={showModal.isShow}
          onCancel={() => setShowModal({ isShow: false, data: null })}
        />
      )}
    </>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }

  .btn-new {
    flex: 0 0 150px;
  }
`
